/**
 * Classe représentant une erreur Http.
 */
export class HttpError {
	/**
	 * Constructeur.
	 * @param code : Code Http.
	 * @param reasonPhrase : Raison de l'erreur.
	 * @param message : Message de l'erreur.
	 * @param innerErrors : Erreurs internes.
	 */
	constructor(
		public code: number,
		public reasonPhrase: string,
		public message: string,
		public innerErrors?: HttpError[]
	) {}
}
